import * as Yup from "yup";

const MessageTemplateSchema = (displayNames: any) => {
  return Yup.object().shape({
    displayName: Yup.string()
      .required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
      )
      .test(
        "is-in-application-list",
        "US.COLLECTION.VALIDATIONS:REQUIRED.DISPLAY_NAME_ALREADY_EXISTS",
        function (value) {
          return !displayNames.includes(value);
        }
      ),
  });
};

export default MessageTemplateSchema;
